module.exports = __webpack_public_path__ + "static/pillow-1-65cb553df0b978fe904c7848886ea6f0.png";